import SearchBar from '@app/components/SearchBar'
import { IAttachment } from '@app/models/Attachment'
import { AttachmentType } from '@app/models/enums'
import { bindFunctions } from '@app/utils/class'
import { filterAttachments } from '@app/utils/filters'
import { List } from 'immutable'
import * as React from 'react'
import { Button, ButtonGroup } from 'reactstrap'
import AttachmentsListItem from '../containers/AttachmentsListItemContainer'

export interface IAttachmentsListProps {
  attachments: List<IAttachment>
  className?: string
  noFilter?: boolean
  noSort?: boolean
  onChange: (e: List<IAttachment>) => void
  propertyId?: string
  style?: React.CSSProperties
}

enum SortOption {
  Date = 'dateCreated',
  Name = 'name',
}

interface IAttachmentsListState {
  filterText: string
  sortBy: SortOption
}

export class AttachmentsList extends React.PureComponent<
  IAttachmentsListProps,
  IAttachmentsListState
> {
  constructor(props: IAttachmentsListProps) {
    super(props)

    this.state = {
      filterText: '',
      sortBy: SortOption.Name,
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <div className={this.props.className} style={this.props.style}>
        {this.props.noFilter !== true && (
          <SearchBar
            className='mb-2'
            onChange={this._setFilterText}
            placeholder='Filter attachments...'
            size='sm'
            value={this.state.filterText}
          />
        )}
        {this.props.noSort !== true && (
          <div className='d-flex mb-2 align-items-center'>
            <span className='text-muted small mr-2'>Sort by</span>
            <ButtonGroup>
              <Button
                color='link'
                size='sm'
                onClick={() => this._setSortBy(SortOption.Name)}
                active={this.state.sortBy === SortOption.Name}
              >
                Name
              </Button>
              <Button
                color='link'
                size='sm'
                onClick={() => this._setSortBy(SortOption.Date)}
                active={this.state.sortBy === SortOption.Date}
              >
                Date
              </Button>
            </ButtonGroup>
          </div>
        )}
        <div className='mb-2'>{this._renderAttachments()}</div>
      </div>
    )
  }

  private _renderAttachments() {
    const filteredAttachments = !this.state.filterText
      ? this.props.attachments
      : this.props.attachments
          .filter(filterAttachments(this.state.filterText))
          .toList()

    const sortBy = this.state.sortBy

    const sortedAttachments = filteredAttachments.sortBy((a) => {
      if (a === undefined) {
        return undefined
      }

      return sortBy === SortOption.Date ? a.dateCreated : a.title
    })

    return sortedAttachments.map((a, i) => {
      if (a === undefined || i === undefined) {
        return null
      }

      if (
        a.type === AttachmentType.Photo ||
        a.type === AttachmentType.MainPhoto
      ) {
        return null
      }

      return (
        <AttachmentsListItem
          key={a.id}
          attachment={a}
          className={i % 2 === 1 ? 'striped-row' : undefined}
          onChange={(e: IAttachment) => {
            if (this.props.onChange) {
              this.props.onChange(
                List(
                  this.props.attachments.map((item: any) => {
                    if (item.id === e.id) {
                      return e
                    }

                    return item
                  }),
                ),
              )
            }
          }}
          propertyId={this.props.propertyId}
        />
      )
    })
  }

  private _setFilterText(newFilterText: string) {
    this.setState({ filterText: newFilterText })
  }

  private _setSortBy(newSortBy: SortOption) {
    this.setState({ sortBy: newSortBy })
  }
}
